import type { ProjectSortKey, UserPreferences } from '../api-clients/types.js';
import { isProjectSortKey } from '../query/project-sort.js';

/**
 * localStorage mirror of the DB-backed display preferences. The database is
 * the source of truth (rides /me); the mirror exists only for the one place
 * async data can't reach — synchronous route-match-time reads. Never treat
 * the mirror as authoritative. See docs/features/user-preferences/design.md.
 */
export const PROJECTS_SORT_STORAGE_KEY = 'eco-platform.projects-list-sort';

export type ProjectsListSort = ProjectSortKey;

// localStorage access is a system boundary: it throws in private-browsing /
// storage-denied contexts, where the preference silently degrades to the
// default.
export function readStoredProjectsSort(): ProjectsListSort | null {
  try {
    const raw = localStorage.getItem(PROJECTS_SORT_STORAGE_KEY);
    return isProjectSortKey(raw) ? raw : null;
  } catch {
    return null;
  }
}

export function writeStoredProjectsSort(sort: ProjectsListSort): void {
  try {
    if (localStorage.getItem(PROJECTS_SORT_STORAGE_KEY) === sort) return;
    localStorage.setItem(PROJECTS_SORT_STORAGE_KEY, sort);
  } catch {
    // storage denied — the preference just doesn't persist
  }
}

/** Server → mirror: called when /me resolves. */
export function syncPreferencesMirror(preferences: UserPreferences): void {
  if (preferences.projectsListSort) writeStoredProjectsSort(preferences.projectsListSort);
}
